<template>
  <div class="gp-main-body-content">
    <div id="subpages">
      <Portal to="headerActions" v-if="inRoute">
        <div class="d-flex justify-content-end flex-grow-1">
          <ButtonAddShop @openAddShopModal="openAddShopModal()" />
        </div>
      </Portal>

      <div class="section pt-1">
        <div class="list-pages">
          <template v-if="shops.loading">
            <GpListLoading :quantity="5" />
          </template>

          <div class="d-flex justify-content-end mb-3">
            <div class="tab-item text-secondary3 d-flex">
              <div class="d-flex align-items-center mr-3">
                <span class="typo-button14 text-light-high">{{ $t("generals.sort") }}:</span>
                <SortShop @change="doSort" lclass="dropdown" type="shops" />
              </div>
              <div class="page-search">
                <GpInputSearch v-model="query" :indicating="false" :placeholder="$t('agency.searchShop')" />
              </div>
            </div>
          </div>
          <GpList class="shops-list d-flex flex-column">
            <template v-slot:GpListItem>
              <template v-if="shops.fetched">
                <template v-if="sortedShopList && sortedShopList.length">
                  <ShopItem class="page-item d-flex align-items-center mb-2 noBorderHover" v-for="(item, index) in sortedShopList" :key="index" :shop="item" :pageType="type" @openEditor="openEditor" :isAgencyDashboard="true" />
                  <Pagination :pagina.sync="pagination" :total.sync="totalPagesPagination" @page="toPage" v-if="totalPages > pagination.limit" />
                </template>
                <template v-else>
                  <GpEmptyPage page="shop" :customContent="true">
                    <template #button="{}" v-if="!allShop || !allShop.length">
                      <div class="d-flex justify-content-center align-items-center">
                        <ButtonAddShop @openAddShopModal="openAddShopModal()"></ButtonAddShop>
                      </div>
                    </template>

                    <template #content>
                      <template v-if="!allShop || !allShop.length">{{ $t("empty.shop.content") }}</template>
                      <template v-else>{{ $t("empty.shop.query") }}</template>
                    </template>
                  </GpEmptyPage>
                </template>
              </template>
              <template v-else>
                <template v-if="shops.status.loading">
                  <GpListLoading type="shop" />
                </template>
                <template v-else>
                  <GpEmptyPage page="shop" :customContent="true">
                    <template #button="{}" v-if="!allShop || !allShop.length">
                      <div class="d-flex justify-content-center align-items-center">
                        <button class="btn btn-primary" :disabled="shops.status.loading" @click="fetchShopList({ type: 'shopList' })">{{ $t("empty.shop.fetch") }}</button>
                      </div>
                    </template>
                    <template #content>{{ $t("empty.shop.notFetched") }}</template>
                  </GpEmptyPage>
                </template>
              </template>
            </template>
          </GpList>

          <GpEmptyPage :customContent="true" :page="type" v-if="query != '' && filteredList.length == 0">
            <template #button></template>
            <template #content>
              <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">{{ $t("search.noResult", { keyword: query }) }}</p>
              <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("page.searchEmpty") }}</p>
            </template>
          </GpEmptyPage>
        </div>
      </div>

      <!-- Search Empty Page -->
      <!-- <GpEmptyPage :customContent="true" :customTitle="true" :page="type" v-if="query != '' && (!filteredList || !filteredList.length)">
        <template #button></template>
        <template #content>
          <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">{{ $t("search.noResult", { keyword: query }) }}</p>
          <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("page.searchEmpty") }}</p>
        </template>
      </GpEmptyPage> -->

    </div>
    <Modal classs @cancel="closeModal" v-if="modalAddShop" @container="closeModal">
      <template #header>
        <h3 class="typo-title1">{{ $t("agency.addAShop") }}</h3>
      </template>
      <form @submit.prevent="onClickAddShop()" class="form-group">
        <div class="form-group">
          <label class="typo-body2 label text-black1">{{ $t("agency.domain") }}</label>
          <input
            v-focus
            class="input-field input-field-border typo-body2"
            :class="{
              'is-error': formControl.error.other || formControl.error.email
            }"
            autocomplete="agency-email"
            type="text"
            v-model="formControl.domain"
          />
        </div>
        <p class="lh-16 text-red typo-subtext mt-2 mb-n4" v-if="formControl.error.other">{{ formControl.error.other }}</p>
      </form>
      <template #footer>
        <div class="btn-group">
          <button class="btn btn-outline ml-auto" @click="closeModal">{{ $t("generals.cancel") }}</button>
          <ProcessButton class="" :status.sync="btnStatus" type="submit" default="btn-primary" @click="onClickAddShop()">
            <template #loading>{{ $t("generals.add") }}</template>
            <template #success>{{ $t("generals.success") }}</template>
            <template #error>{{ $t("generals.add") }}</template>
            <template #default>{{ $t("generals.add") }}</template>
          </ProcessButton>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
let windowObjectReference = null;
let previousUrl = null;
import { serverDomain } from "@/config/index.js";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
import GpListLoading from "@/core/shared/GpList/components/GpListLoading";

import { ButtonAddShop, ShopItem, SortShop } from "../components";
import { GpInputSearch } from "@/core/shared/GpForms";
import Pagination from "@/core/shared/essenstials/Pagination";

import GpList from "@/core/shared/GpList";
import GpTabs, { GpTabContent } from "@/core/shared/GpTabs";
import { types } from "@/store";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { ProcessButton } from "@/core/shared";

export default {
  name: "AgencyDashboard",
  components: {
    ShopItem,
    Pagination,
    GpList,
    GpTabs,
    SortShop,
    GpTabContent,
    ButtonAddShop,
    ProcessButton,
    GpEmptyPage,
    GpInputSearch,
    GpListLoading
  },
  data() {
    return {
      inRoute: false,
      type: "shopList",
      pagination: {
        page: 1,
        limit: 5
      },
      fetched: false,
      btnStatus: {
        loading: false,
        success: false,
        error: false
      },
      modalAddShop: false,
      formControl: {
        domain: "",
        email: "",
        password: "",
        error: {
          email: null,
          password: null,
          other: null
        },
        showPassword: false
      },
      sortType: "addedDate",
      query: ""
    };
  },
  computed: {
    ...mapState({
      shopInfo: state => state.account.shopInfo
    }),
    ...mapState("agency", {
      shops: state => state.shopList,
    }),
    ...mapGetters("agency", {
      shopList: "shopList"
      // allShop: "sortedShopList"
    }),
    allShop() {
      if (!this.shops || !this.shops.list || !this.shops.list.length) {
        return [];
      }
      return this.shops.list
        .map(x => x)
        .sort((shopA, shopB) => {
          switch (this.sortType) {
            case "nameAsc":
              if (shopA.profile.name.toLowerCase() > shopB.profile.name.toLowerCase()) {
                return 1;
              } else {
                return -1;
              }
            case "nameDesc":
              if (shopA.profile.name.toLowerCase() < shopB.profile.name.toLowerCase()) {
                return 1;
              } else {
                return -1;
              }
            case "plan":
              if (shopA.plan > shopB.plan) {
                return 1;
              } else {
                return -1;
              }
            case "addedDate":
              if (shopA.agency_created > shopB.agency_created) {
                return 1;
              } else {
                return -1;
              }
          }
        });
    },
    filteredList() {
      return this.allShop.filter(item => {
        if (((item.profile && item.profile.name) || "").toLowerCase().indexOf((this.query || "").toLowerCase()) > -1) return true;
        if ((item.shopify_domain || "").toLowerCase().indexOf((this.query || "").toLowerCase()) > -1) return true;
        return false;
      });
    },
    totalPagesPagination() {
      return Math.ceil(this.filteredList.length / this.pagination.limit);
    },
    totalPages() {
      return this.shopList.list.length;
    },
    sortedShopList() {
      return this.filteredList.slice((this.pagination.page - 1) * this.shopList.pagination.limit, this.pagination.page * this.shopList.pagination.limit);
    }
  },
  created() {
    // this.fetchPages({ type: "recentPage" });
    this.fetchShopList({ type: "shopList" });
  },
  mounted() {
    this.inRoute = true;
  },
  beforeDestroy() {
    this.inRoute = false;
  },
  methods: {
    ...mapActions("agency", {
      fetchShopList: "fetchShopList",
      updateShopPagination: "updateShopPagination",
      addShop: "addShop",
      checkLinkedAgency: "checkLinkedAgency"
    }),
    ...mapMutations("agency", { ...types.agency.mutations }),
    openAddShopModal() {
      this.modalAddShop = true;
    },
    closeModal() {
      this.modalAddShop = false;
    },
    openEditor() {},
    doSort(value) {
      this.sortType = value;
    },
    toPage(page) {
      this.pagination.page = page;
      this.updateShopPagination(page);
    },
    onClickAddShop() {
      if (this.formControl.domain.trim() == "") {
        this.gSnackbarCommit({
          message: this.$t("agency.domainCantNotEmpty"),
          type: "error"
        });
        return;
      }
      this.btnStatus.loading = true;
      this.checkLinkedAgency(this.formControl.domain)
        .then(() => {
          window.removeEventListener("message", this.receiveMessage());

          let domain = serverDomain();
          let url = `${domain}/login?shop=${this.formControl.domain}`;
          let windowName = "Gempages";

          const strWindowFeatures = "toolbar=no, menubar=no, width=600, height=700, top=100, left=100";
          if (windowObjectReference === null || windowObjectReference.closed) {
            /* if the pointer to the window object in memory does not exist
          or if such pointer exists but the window was closed */
            windowObjectReference = window.open(url, windowName, strWindowFeatures);
          } else if (previousUrl !== url) {
            /* if the resource to load is different,
          then we load it in the already opened secondary window and then
          we bring such window back on top/in front of its parent window. */
            windowObjectReference = window.open(url, windowName, strWindowFeatures);
            windowObjectReference.focus();
          } else {
            /* else the window reference must exist and the window
          is not closed; therefore, we can bring it back on top of any other
          window with the focus() method. There would be no need to re-create
          the window or to reload the referenced resource. */
            windowObjectReference.focus();
          }

          // add the listener for receiving a message from the popup
          window.addEventListener("message", event => this.receiveMessage(event), false);

          windowObjectReference.addEventListener("unload", () => {
            this.btnStatus.loading = false;
          });

          windowObjectReference.addEventListener("load", () => {
            this.btnStatus.loading = true;
          });
          // assign the previous URL
          previousUrl = url;
        })
        .catch(() => {
          this.btnStatus.loading = false;
          this.gSnackbarCommit({
            message: this.$t("agency.shopIslinked"),
            type: "error"
          });
        });
    },
    receiveMessage() {
      if (windowObjectReference && windowObjectReference.opener) {
        if (typeof windowObjectReference.__gem_shopInfo != "undefined") {
          // close the popup
          this.closeModal();
          this.fetchShopList({ type: "shopList", reFetch: true });
          this.btnStatus.loading = false;
          windowObjectReference.close();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
}

.shops-list {
  min-height: 526px;
  .pagination::v-deep {
    margin-top: auto;
    padding-top: 14px;
  }
}
</style>
